var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTableTravelInsuranceTypeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.4,
    height: 20.399,
    viewBox: "0 0 20.4 20.399",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12016",
    "data-name": "Group 12016",
    transform: "translate(-478.89 -424.484)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6",
    transform: "translate(478.89 424.484)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3935",
    "data-name": "Path 3935",
    d: "M94.083,180.993a.4.4,0,1,0-.282.117A.4.4,0,0,0,94.083,180.993Zm0,0",
    transform: "translate(-89.681 -173.128)",
    fill: "#199b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3936",
    "data-name": "Path 3936",
    d: "M2.144,441.234.117,443.261a.4.4,0,1,0,.563.563L2.707,441.8a.4.4,0,1,0-.563-.563Zm0,0",
    transform: "translate(0 -423.542)",
    fill: "#81b830"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3937",
    "data-name": "Path 3937",
    d: "M.4,225.113A.4.4,0,0,0,.68,225l2.227-2.227a.4.4,0,1,0-.564-.564L.117,224.433a.4.4,0,0,0,.282.68Zm0,0",
    transform: "translate(0 -213.24)",
    fill: "#81b830"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3938",
    "data-name": "Path 3938",
    d: "M222.76,467.648l-.975.975a.4.4,0,1,0,.563.563l.975-.974a.4.4,0,1,0-.563-.564Zm0,0",
    transform: "translate(-212.837 -448.903)",
    fill: "#81b830"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3939",
    "data-name": "Path 3939",
    d: "M20.2,10.82,15.8,8.2l2.985-2.985A5.533,5.533,0,0,0,20.324.4.4.4,0,0,0,20,.075a5.532,5.532,0,0,0-4.813,1.542l-2.82,2.82-1.28-.122A1.224,1.224,0,0,0,9.053,3.078L8.1,4.03,6.838,3.91A1.224,1.224,0,0,0,4.811,2.66l-.964.964L2.213,3.469a.4.4,0,0,0-.32.115L.117,5.36A.4.4,0,0,0,.214,6L2.521,7.2a.4.4,0,1,0,.368-.706L1.064,5.54l1.26-1.26,9.309.888L7.766,9.035,5.725,7.971a.4.4,0,0,0-.369.707l1.818.948-.626.626a11.9,11.9,0,0,0-1.632,2.035l-3.465.064a.4.4,0,0,0-.274.117l-.926.926a.4.4,0,0,0,.154.659l3.2,1.079a11.965,11.965,0,0,0-.37,1.575.4.4,0,0,0,.458.458,11.965,11.965,0,0,0,1.575-.37l1.079,3.2a.4.4,0,0,0,.287.261.4.4,0,0,0,.091.01.4.4,0,0,0,.282-.117l.926-.926a.4.4,0,0,0,.117-.275l.06-3.463a11.863,11.863,0,0,0,1.75-1.357,7.519,7.519,0,0,0,5.118,6.251.4.4,0,0,0,.25,0A7.52,7.52,0,0,0,20.4,13.226V11.163a.4.4,0,0,0-.195-.343ZM9.616,3.642a.427.427,0,0,1,.615.592l-1.1-.105ZM5.374,3.224a.427.427,0,1,1,.6.6h0l-1.1-.105ZM1.269,13.5l.358-.358,2.822-.052a11.72,11.72,0,0,0-.584,1.286Zm5.987,5.27-.358.358-.876-2.6A11.708,11.708,0,0,0,7.3,15.952Zm.272-3.864-.035.021a10.978,10.978,0,0,1-3.363,1.34,10.982,10.982,0,0,1,2.983-5.454l8.634-8.634A4.735,4.735,0,0,1,19.577.822a4.735,4.735,0,0,1-1.359,3.83L15.005,7.867a.4.4,0,0,0-.105.043L10,10.82a.4.4,0,0,0-.2.343v1.9l-.222.222a11.084,11.084,0,0,1-2.057,1.622ZM19.6,13.226a6.724,6.724,0,0,1-4.5,6.354,6.724,6.724,0,0,1-4.5-6.317.4.4,0,0,0,0-.075v-1.8l4.5-2.674,4.5,2.674Zm0,0",
    transform: "translate(0 0)",
    fill: "#199b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3940",
    "data-name": "Path 3940",
    d: "M289.624,243.7l-3.3,1.963a.4.4,0,0,0-.2.343v1.157a5.937,5.937,0,0,0,3.542,5.435.4.4,0,0,0,.321,0,5.937,5.937,0,0,0,3.542-5.435V246a.4.4,0,0,0-.195-.343l-3.3-1.963A.4.4,0,0,0,289.624,243.7Zm3.109,2.533v.93a5.141,5.141,0,0,1-2.906,4.631,5.141,5.141,0,0,1-2.906-4.631v-.93l2.906-1.727Zm0,0",
    transform: "translate(-274.725 -233.932)",
    fill: "#81b830"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3941",
    "data-name": "Path 3941",
    d: "M350.348,324.124a.4.4,0,0,0-.563.564l.649.649a.4.4,0,0,0,.564,0l1.579-1.579a.4.4,0,0,0-.563-.564l-1.3,1.3Zm0,0",
    transform: "translate(-335.736 -310.205)",
    fill: "#81b830"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3942",
    "data-name": "Path 3942",
    d: "M337.515,68.058a.4.4,0,0,0,.282-.117l3.636-3.636a.4.4,0,0,0-.563-.563l-3.636,3.636a.4.4,0,0,0,.282.68Zm0,0",
    transform: "translate(-323.685 -61.09)",
    fill: "#199b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3943",
    "data-name": "Path 3943",
    d: "M309.23,183.957a.4.4,0,1,0-.282-.117A.4.4,0,0,0,309.23,183.957Zm0,0",
    transform: "translate(-296.527 -175.862)",
    fill: "#199b8b"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableTravelInsuranceTypeIcon);
export default __webpack_public_path__ + "static/media/table-travel-insurance-type-icon.a01890a28a8d2be922b7cbd5a9c4b12a.svg";
export { ForwardRef as ReactComponent };